<div class="contents">
  @if (card.previewTab.outputData.length > 0 && !card.hasError) {
    @if (card.hasAnyDataPoints) {
      <div class="plot-border">
        <div class="backupScreenshot"
          [style.position]="'relative'"
        ></div>
        @for (_data of (card.previewTab.graphConfig | pureFnCall:has3DTraces) ? [card.previewTab.outputData] : [null]; track _data) {
          <div class="contents"
            #plotWrapper
            >
            @if (plotting === true) {
              <plotly-plot
                #thePlot
                [attr.data-plotid]="id"
                [divId]="'plotlyDiv-' + id"
                [data]="card.previewTab.outputData"
                [updateOnlyWithRevision]="true"
                [revision]="thePlot.plotlyInstance === undefined ? -1 : card.revision"
                [layout]="card.previewTab.layout"
                [config]="card.previewTab.plotlyConfig"
                [className]="'flex-1 overflow-hidden'"
                (initialized)="onPlotInitialized(id, card)"
                (hover)="hover($event, id)"
                (unhover)="unhover($event, id)"
                class="contents">
              </plotly-plot>
            }
          </div>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="placeholderContent; context: {
        message: 'Waiting for data...',
        linkText: undefined,
        routerLinkValue: undefined,
      }">
      </ng-container>
    }
  } @else if (card.hasError) {
      <ng-container *ngTemplateOutlet="placeholderContent; context: {
      message: 'Error while loading data',
        linkText: undefined,
        routerLinkValue: undefined
      }"></ng-container>
  } @else if (card.isLoading) {
    <ng-container *ngTemplateOutlet="placeholderContent; context: {
      message: 'Loading',
      linkText: undefined,
      routerLinkValue: undefined,
    }">
    </ng-container>
  } @else if (!card.previewTab.graphConfig.internalSeriesList.length) {
    <ng-container *ngTemplateOutlet="placeholderContent; context: {
      message: 'No dashboard card configured',
      linkText: 'Configure now',
      routerLinkValue: card.isStack
              ? [urls.route.dashboardStackGraphConfiguration(card.thingieIds[0])]
              : [urls.route.thingieGraphConfiguration(card.thingieIds[0])]
    }">
    </ng-container>
  } @else if (card.hasAnyDataPoints === false) {
    <ng-container *ngTemplateOutlet="placeholderContent; context: {
      message: 'No data to show',
      linkText: undefined,
      routerLinkValue: undefined
    }"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="placeholderContent; context: {
      message: 'Data could not be loaded',
      linkText: undefined,
      routerLinkValue: undefined
    }"></ng-container>
  }

  <ng-template
    #placeholderContent
    let-message="message"
    let-link="linkText"
    let-routerLinkValue="routerLinkValue"
    >
    <div
      class="graph-placeholder-container"
      >
      <div class="image-container">
        <ion-icon [src]="urls.asset.svg.analyticsDim"></ion-icon>
      </div>
      <div class="message-pane">
        <div class="mat-body-2">
          {{ message }}
          @if (link && routerLinkValue) {
            <br />
            <a [routerLink]="routerLinkValue">
              {{ link }}
            </a>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <div class="task-status-bar">
    @if ((card.thingieIds | pureFnCall:getThingiesByIds | async) || []; as thingies) {
      <app-task-status-bar
        [taskKey]="{thingies: thingies}"
      ></app-task-status-bar>
    }
  </div>
</div>

<!-- Hover template -->
<ng-template #hovertemplate [app-context-type]="hovertemplateContextType" let-hoverinfo="hoverinfo">
  <div class="hovertemplate"
    [style.border-color]="hoverinfo.color"
    >
    <b>Series:</b> {{hoverinfo.name}}<br/>
    <b>Time:</b> {{hoverinfo.time}}<br/>
    <b>Value:</b> {{hoverinfo.value}} {{hoverinfo.unit ? '['+hoverinfo.unit+']' : ''}}<br/>
  </div>
</ng-template>
